import React from "react"

import { InputBasic } from "../../../components/utils/InputBasic"
import { ToggleSwitch } from "../../../components/utils/ToggleSwitch"

export const NumericRestriction = ({ state, setstate, blurHandler, changeHandler }) => {
    const formSections: Record<string, string[]> = {
        'configuration': ["format", "display_style", "minimum", "maximum", "unit_label"],
    }

    const toggleVisibility = (key: any, value: boolean) => {
        setstate((prevState: any) => ({
            ...prevState,
            show: {
                ...prevState.show,
                [key]: value,
            },
        }))
    }

    const toogleSwitchHandler = (e: any) => {
        let { input, posting } = state
        if (posting) return

        switch (e.target.name) {
            case 'whole_numbers':
            case 'allow_negative':
                if (input.format?.key !== 'numeric') return
                break;

            default:
                break;
        }

        setstate((prev: any) => ({
            ...prev,
            input: {
                ...prev.input,
                [e.target.name]: e.target.checked
            }
        }))
    }

    const findSection = (fieldName: string) => {
        // Find section in which input belongs
        for (const [section, fields] of Object.entries(formSections)) {
            if (fields.includes(fieldName)) {
                return section;
            }
        }
        return null;
    }

    const sectionHasErrors = (section: string, errors: Record<string, string>) => {
        const fields = formSections[section] || [];
        // If any field still has an error
        return fields.some((field) => errors[field]);
    }

    const hideRangeVisibility = () => {
        toggleVisibility('minMaxVisibility', false)
        let { errors } = state

        const sectionWithError = findSection('minimum')
        const stillHasErrors = sectionHasErrors(sectionWithError, errors)

        setstate((prev: any) => ({
            ...prev,
            input: {
                ...prev.input,
                minimum: '',
                maximum: '',
            }, errors: {
                ...prev.errors,
                minimum: '',
                maximum: '',
                [sectionWithError]: stillHasErrors ? errors[sectionWithError] : ''
            }
        }))
    }

    return (
        <React.Fragment>
            <div className="w-full pb-2">
                <p className="text-sm text-slate-800 dark:text-slate-200 truncate pb-1 uppercase">
                    Unit Label
                </p>

                <span className="block text-sm text-slate-500 dark:text-slate-400 py-1 pb-3">
                    Specify the unit that describes this value, such as “months,” “kg,” or “USD”
                </span>

                <div className="mb-3 md:max-w-[300px]">
                    <InputBasic
                        name={"unit_label"}
                        placeHolder={"Unit Label"}
                        required={true}
                        posting={state.posting}
                        blurHandler={blurHandler}
                        changeHandler={changeHandler}
                        value={state.input.unit_label}
                        error={state.errors.unit_label}
                    />
                </div>
            </div>

            <div className="w-full py-4">
                <ToggleSwitch
                    label={'Whole Numbers Only'}
                    name={'whole_numbers'}
                    checked={state.input.whole_numbers}
                    changeHandler={toogleSwitchHandler}
                    description={"Restrict values to integers with no decimals"}
                />
            </div>

            <div className="w-full py-4 border-t border-slate-300 dark:border-slate-600">
                <ToggleSwitch
                    label={'Allow Negative Values'}
                    name={'allow_negative'}
                    checked={state.input.allow_negative}
                    changeHandler={toogleSwitchHandler}
                    description={"Permit negative numbers, such as −5 or −100."}
                />
            </div>

            <div className="w-full py-4 border-t border-slate-300 dark:border-slate-600">
                <ToggleSwitch
                    label={'Required?'}
                    name={'mandatory'}
                    checked={state.input.mandatory}
                    changeHandler={toogleSwitchHandler}
                    description={"Ensures a value is provided before submitting"}
                />
            </div>

            <div className="w-full pb-5">
                <button type="button" onClick={() => toggleVisibility('minMaxVisibility', true)} className={`text-orange-500 md:py-0 hover:text-orange-700 ${state.show.minMaxVisibility ? 'hidden' : 'block mt-2 md:mb-0 mb-3'}`}>
                    <span className="text-sm">Limit Value Range</span>
                </button>

                {
                    state.show.minMaxVisibility && (
                        <>
                            <div className="w-full pt-4 pb-1 border-t border-slate-300 dark:border-slate-600">
                                <span className="block text-sm text-slate-800 dark:text-slate-200 pb-3">
                                    Limit Value Range

                                    <span className="block text-xs text-slate-500 dark:text-slate-400 py-1">
                                        Define the min and max allowed values
                                    </span>
                                </span>

                                <div className="md:w-80 flex w-full items-center border border-gray-300 rounded-md overflow-hidden">
                                    <input
                                        type="number"
                                        name="minimum"
                                        placeholder="Min"
                                        onBlur={blurHandler}
                                        onChange={changeHandler}
                                        value={state.input.minimum}
                                        className="w-full px-3 py-2 text-sm focus:outline-none focus:ring-0 focus:border-none"
                                    />

                                    <div className="w-px h-6 bg-gray-300 dark:bg-gray-400 mx-1"></div>

                                    <input
                                        type="number"
                                        name="maximum"
                                        placeholder="Max"
                                        onBlur={blurHandler}
                                        onChange={changeHandler}
                                        value={state.input.maximum}
                                        className="w-full px-3 py-2 text-sm focus:outline-none focus:ring-0 focus:border-none"
                                    />
                                </div>
                            </div>

                            {
                                state.errors.minimum.length > 0 && (
                                    <span className='invalid-feedback text-xs block text-red-600 dark:text-red-400 pt-1'>
                                        {state.errors.minimum}
                                    </span>
                                )
                            }

                            {
                                state.errors.maximum.length > 0 && (
                                    <span className='invalid-feedback text-xs block text-red-600 dark:text-red-400 pt-1'>
                                        {state.errors.maximum}
                                    </span>
                                )
                            }

                            <div className="w-full md:w-auto flex flex-row pt-2">
                                <button type="button" onClick={() => hideRangeVisibility()} className={`text-orange-600 dark:text-orange-500 md:py-0 hover:text-orange-700 dark:hover:text-orange-400`}>
                                    <span className="text-sm">Allow Any Value</span>
                                </button>
                            </div>
                        </>
                    )
                }
            </div>
        </React.Fragment>
    )
}